import React from "react";
import { Switch, Route } from "react-router-dom";
import Contactmanagement from "./Index";

export default () => (
  <Switch>
    <Route exact path="/management/contactmanagement" component={Contactmanagement} />
  </Switch>
);
